// assets
import { IconReceipt } from "@tabler/icons";

// constant
const icons = {
  IconReceipt,
};

// ==============================|| FACTURACION MENU ITEMS ||============================== //

const facturacion = {
  id: "Facturacion",
  title: "",
  type: "group",
  children: [
    {
      id: "Facturacion",
      title: "Facturación",
      type: "item",
      url: "/facturacion/facturacion-list",
      icon: icons.IconReceipt,
      breadcrumbs: false,
    },
  ],
};

export default facturacion;
